import * as TYPES from '../types';

const initialState = {
    ongoingProjectList: [],
    upcomingProjectList: [],
};

export function ProjectReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_ONGOING_PROJECT_SUCCESS:
            return {
                ...preState,
                ongoingProjectList: payload,
            };

        case TYPES.GET_ALL_UPCOMING_PROJECT_SUCCESS:
            return {
                ...preState,
                upcomingProjectList: payload,
            };

        default:
            return state;
    }
}